import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import TranslateButton from "../../TranslateButton/TranslateButton";
import "../../../style/resource/auditReport.css";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const AuditReport = () => {
  useEffect(() => {
    document.title = `AshroyAngon | Audit Report`;
  }, []);

  const shareUrl = "https://ashroyangon.org/resources/audit-report";

  return (
    <>
      <Navbar />
      <TranslateButton />

      <div className="audit_report_section">
        {/* Header Background Part Start */}
        <div className="header_background">
          <div className="container wrapper">
            <h2>Audit Report</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div>
        {/* Header Background Part End */}

        <div className="audit_report_wrapper">
          <div className="container">
            <h2>Audit Report</h2>
            <div className="content_wrapper">
              <div className="container">
                <div className="report_wrapper">
                  <div className="report">
                    <p> Audit Report (July 2024 - July 2025)</p>
                    <a
                      href="/Audit-report-July-2024-June-2025.pdf"
                      // download={"Audit-report-July-2024-June-2025.pdf"}
                      target={"_blank"}
                      id="style-2"
                      data-replace="Download Pdf"
                    >
                      <span> Download Pdf</span>
                    </a>
                  </div>
                  <div className="report my-3">
                    <p> Audit Report (July 2023 - July 2024)</p>
                    <a
                      href="/Audit-report-July-2023-June-2024.pdf"
                      // download={"Audit-report-July-2023-June-2024.pdf"}
                      target={"_blank"}
                      id="style-2"
                      data-replace="Download Pdf"
                    >
                      <span> Download Pdf </span>
                    </a>
                  </div>
                  <div className="report">
                    <p> Audit Report (July 2022 - July 2023)</p>
                    <a
                      href="/Audit-report-July-2022-June-2023.pdf"
                      // download={"Audit-report-July-2022-June2023.pdf"}
                      target={"_blank"}
                      id="style-2"
                      data-replace="Download Pdf"
                    >
                      <span> Download Pdf</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AuditReport;
